import request from '../request'

export const successCaseApi = {
  listSuccessCase (params) {
    return request.get('/successCases', { params: params })
  },
  saveSuccessCase (data) {
    return request.post('/successCase', data)
  },
  deleteSuccessCase (id) {
    return request.delete('/successCases/' + id)
  },
  getSuccessCase (id) {
    return request.get('/successCases/' + id)
  },
  updateSuccessCase (id, data) {
    return request.put('/successCases/' + id, data)
  },
}

export default successCaseApi
